import styled from 'styled-components'

export const FavoriteListContainer = styled.div`
  width: calc(100% / 2 - 12px);
  padding: 8px 14px;
  border: 1px solid ${p => p.selected ? p.theme.palette.blue.main : p.theme.palette.colors.borderSoft};
  border-radius: 18px;
  cursor: pointer;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  min-width: 250px;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  box-shadow: ${p => p.dragging ? `0 24px 52px ${p.theme.palette.colors.shadowLift}` : `0 18px 42px ${p.theme.palette.colors.shadowStrong}`};
  opacity: ${p => p.dragging ? 0.6 : 1};
  transition: transform 0.22s ease, box-shadow 0.22s ease, opacity 0.22s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 24px 52px ${p => p.theme.palette.colors.shadowLift};
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`

export const FavoriteListWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  align-items: center;
  min-width: 0;
`

export const SelectionInput = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
`

export const ItemThumb = styled.img`
  width: 54px;
  height: 54px;
  max-height: 100%;
  object-fit: contain;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
  pointer-events: none;
  border-radius: 14px;
  box-shadow: 0 14px 32px ${p => p.theme.palette.colors.shadowStrong};
  flex-shrink: 0;
`

export const FavoriteListMeta = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const FavoriteListTitle = styled.div`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-family: Gilroy;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: ${p => p.theme.palette.colors.text};
`

export const FavoriteTagRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`

export const FavoriteTag = styled.div`
  min-height: 20px;
  border-radius: 999px;
  padding: 3px 8px;
  background: ${p => p.theme.palette.colors.badgeMuted};
  color: ${p => p.theme.palette.colors.text};
  font-family: Poppins;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
`

export const ActionGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`

export const ActionSlot = styled.div`
  display: flex;
  align-items: center;
`

export const ItemActionButton = styled.button`
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.theme.palette.colors.surfaceElevatedStrong};
  color: ${p => p.theme.palette.colors.text};
  cursor: pointer;
  flex-shrink: 0;

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`
export const ItemActionButton2 = styled.div`
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.palette.colors.text};
  cursor: pointer;
  flex-shrink: 0;

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`
